import React, { Component } from 'react';
import DemandeStore from "../DemandeStore"
import {observer} from "mobx-react"

@observer
export default class User extends Component {
  render() {
    let {email,telephone,nom,prenom} = DemandeStore.user
    return (
      <div>
        <div className="container">
          <h2 className="center">Informations propriétaire</h2>
          <div className="row">
            <div className="input-field col s6">
              <i className="material-icons prefix">email</i>
              <input value={email} type="email" onChange={(e)=>DemandeStore.user.email = e.target.value} id="email" />
              <label htmlFor="email" className="active">Email</label>
            </div>
            <div className="input-field col s6">
               <i className="material-icons prefix">phone</i>
                <input value={telephone} type="text" onChange={(e)=>DemandeStore.user.telephone = e.target.value} id="phone"/>
                <label htmlFor="phone" className="active">Téléphone</label>
            </div>
          </div>
          <div className="row">
            <div className="col s6 input-field">
              <i className="material-icons prefix">perm_identity</i>
              <input value={prenom} type="text" onChange={(e)=>DemandeStore.user.prenom = e.target.value} id="prenom"/>
              <label htmlFor="prenom" className="active">Prénom</label>
            </div>
            <div className="col s6 input-field">
              <i className="material-icons prefix">perm_identity</i>
              <input value={nom} type="text" id="nom" onChange={(e)=>DemandeStore.user.nom = e.target.value}/>
              <label htmlFor="nom" className="active">nom</label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
